import { IsArray, IsDefined, IsInt, IsNumber, IsOptional } from 'class-validator';
import { Type } from 'class-transformer';

export class GetStandAloneStockEntryDto {
  @IsDefined()
  @IsInt()
  merchantId: number;

  @IsOptional()
  @IsArray()
  @IsNumber({}, { each: true })
  stockCategoryIdList?: number[];

  @IsOptional()
  @IsArray()
  @IsNumber({}, { each: true })
  stockCategoryLev1IdList?: number[];

  @IsOptional()
  @IsArray()
  @IsNumber({}, { each: true })
  stockCategoryLev2IdList?: number[];

  @IsOptional()
  @IsInt()
  @Type(() => Number)
  supplierId?: number;

  @IsOptional()
  search?: string;
}
